import React, { useCallback, useMemo } from "react"
import { Box, useTheme, Button } from "@mui/material"
import TrainIcon from "@mui/icons-material/Train"
import { useNavigate } from "react-router-dom"
import _ from "lodash"

import { MotionDiv } from "components/motions"
import { Head } from "components/Head"
import { useTranslation } from "providers/i18n"
import { useBtsDetail } from "extensions/em-transportation/hooks/useBtsDetail"
import { Image } from "components/Image"
import { useExtension } from "hooks/extension/useExtension"
import { TransportationImageModal } from "extensions/em-transportation/components/TransportationImageModal"

export const EmBtsTransportationMobilePage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { extensionConfig } = useExtension()
  const btsConfig = useMemo(
    () => _.get(extensionConfig, "em-transportation.options"),
    [extensionConfig]
  )

  const btsLocationLinks = useMemo(
    () => _.get(btsConfig, "bts.locations", []),
    [btsConfig]
  )

  const {
    locationLinks,
    openImageModalState,
    openImageModal,
    closeImageModal,
  } = useBtsDetail(btsLocationLinks, btsConfig)

  const theme = useTheme()
  const btsImage = useMemo(() => _.get(theme, "assets.bts.url"), [theme])
  const btsMapImage = useMemo(() => _.get(theme, "assets.btsMap.url"), [theme])
  const styleOverrides =
    theme.components[`EmBtsTransportationPage`]?.styleOverrides || {}
  const { root, image, imageContainer, locationButtons, button, mapButton } =
    styleOverrides

  const onClickBtsLocation = useCallback(
    (id) => {
      navigate(`/maps/place/${id}`)
    },
    [navigate]
  )

  return (
    <>
      <Head title={t("Transportation (BTS)")} />
      <MotionDiv
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.15 }}
      >
        <Box sx={root}>
          <Box sx={imageContainer}>
            <Image sx={image} src={btsImage} />
            <Button
              size="small"
              variant="text"
              sx={mapButton}
              onClick={openImageModal}
            >
              CLICK TO SEE BTS SKYTRAIN ROUTE MAP
            </Button>
          </Box>
          <Box sx={locationButtons}>
            {locationLinks.map((data) => {
              const { id, location, name } = data
              return (
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<TrainIcon />}
                  sx={button}
                  key={id}
                  onClick={() => onClickBtsLocation(location?.id)}
                >
                  {t(name)}
                </Button>
              )
            })}
          </Box>
        </Box>
      </MotionDiv>
      <TransportationImageModal
        open={openImageModalState}
        onClose={closeImageModal}
        imageSrc={btsMapImage}
      />
    </>
  )
}
